import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function ProjetInformatique({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        {variablesData.genre_masc_complet}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Il y a quelques mois, vous nous avez fait part d'un projet visant à
        implanter un système informatisé capable de gérer à la fois les aspects
        administratifs liés à la gestion du personnel ainsi que la documentation
        technique.
      </p>
      <p>
        Il existe actuellement sur le marché un logiciel qui permet de gérer ces
        aspects ainsi que les données clients.
      </p>
      <p>
        J'ai eu l'occasion d'échanger récemment avec les autres Directeurs
        Régionaux sur ce sujet, ils semblent ouverts à trouver une solution
        commune.
      </p>
      <p>
        Je serais fort intéressée à piloter ce projet en collaboration avec les
        2 autres régions. Notre Direction pouvant être force de proposition et
        responsable de l'implantation du logiciel.
      </p>
      <p>Je joins en annexe une présentation du projet en 3 temps.</p>
      <p>
        Compte tenu de l'ampleur de ce projet, il y a urgence à lancer le
        chantier.
      </p>
      <p>Qu'en pensez-vous ?</p>
      <p>Je vous remercie de me faire part de votre décision rapidement,</p>
      <p>Cordialement,</p>
      <MailSignature
        emetteurLogo={ProjetInformatique.metadata.emetteurLogo}
        emetteur={ProjetInformatique.metadata.emetteur}
        emetteurPoste={ProjetInformatique.metadata.emetteurPoste}
        emetteurEntreprise={ProjetInformatique.metadata.emetteurEntreprise}
      />
    </div>
  );
}

ProjetInformatique.metadata = {
  titre: "Projet Informatique",
  cleMail: "projet_informatique",
  messageTransfert: false,
  emetteur: "Marie-France STOVANOVIC",
  emetteurPoste: "Responsable Informatique",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -9,
  piecesJointes: ["projet-informatique"],
} as MailMetadata;

export default ProjetInformatique;
